import React from 'react';

export default function() {
  return (
    <div id="description">
      <h3>Interactive Tree</h3>
      <section>
        <p>Clicking behavior:</p>
        <ul>
          <li>Clicking on a child node will exhange it's location with its parent.</li>
          <li>Clicking on the original tree root will change its color but not location while it is the root.</li>
          <li>While nodes are exchange, clicking is disabled.</li>
        </ul>
      </section>
      <section>
        <p>The purpose of this demonstration is a mock-up for a categorizing the score of Machine Learning Annotations.</p>
        <p>The full implementation would add these features:</p>
        <ul>
          <li>Nodes are arranged as a Heap, where nodes with a high score are higher in the Heap and denoted with a
            color closer to red.</li>
          <li>The user of the Machine Learning annotation system, would see which tasks need to be improved by how low
            they are on the Heap.</li>
          <li>Clicking on a node would display the task that needs to be improved.</li>
          <li>The user would then be able to alter the Machine Leaning annotations for the displayed task.</li>
          <li>Closing the displayed task would update the score, and bubble up the node to its new location
            based on the new score.</li>
        </ul>
      </section>

    </div>
  );
}